import { useParentDataPrefill } from "features/sign-up/common-routes/components/hooks";

import SignInCardCommon, { SignInCardCommonProps } from "../SignInCardCommon";

type Props = Omit<SignInCardCommonProps, "prefilledEmail" | "loading">;

export default function SignInCardParent(props: Props) {
  const { parentData, isParentDataLoading } = useParentDataPrefill();

  return (
    <SignInCardCommon
      prefilledEmail={parentData?.email}
      loading={isParentDataLoading}
      headerMessage={`${props.action} to monitor your child's progress`}
      {...props}
    />
  );
}
